import React, { useState, useEffect } from "react";
import ApiService from "../services/ApiService";
import { toast } from "react-toastify";
import { Table,Container } from "react-bootstrap";

const ReviewScreen = ({setQuestionIndex,subset,attempt_id}) => {
  
  const [incomplete_questions, setIncompleteQuestions] = useState(null);
  const [questions, setQuestions] = useState(null);
  const [isLoading, setLoading] = useState(true);


  const getNavigatorData = async () => {
    try {
      setLoading(true);
      const response = await ApiService.request({
          method: "GET",
          url: `getNavigatorData`,
          params: {"subset_id":subset.id,attempt_id},
        });
      const data = response.data;

      if (data && data.status === true) {
        setQuestions(data.data);
        setIncompleteQuestions(data.incomplete_questions);
      } else {
        toast.error(data.message || "Failed to fetch packages.");
      }
    } catch (error) {
      console.error("Error fetching packages:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getNavigatorData();
  }, []);

  const moveToQuestion = (index) =>{
    setQuestionIndex(index);
  }
  

  return (
    <Container className="mt-5 mb-10">
      <h5> {subset.title}  Review Prescore: use this screen to review the items and amend your responses .</h5>
      <Table bordered className="text-center table-striped mx-auto mt-5">
        <thead className="table-primary">
          <tr >
            <th className="text-start" colSpan={2}>Practice Test A - {subset.title} </th>
            <th className="text-end">{incomplete_questions} Unseen/ Incomplete</th>
          </tr>
          <tr >
            <th className="text-start">Question #</th>
            <th>Status</th>
            <th>Flagged - Review</th>
          </tr>
        </thead>
        <tbody>
        {!isLoading && questions ? (
            questions.map((question, index) => (
              <tr key={index}>
                <td><a href="#" onClick={() => moveToQuestion(index)} className="nav-link text-primary"> Question {index + 1} </a></td>
                <td className={`${question.attempt_status === 'Attempted' ? 'text-success' : 'text-danger'}`}>{question.attempt_status}</td>
                <td>
                  <i className={question.is_flagged ? "bi bi-flag-fill text-danger" : "bi bi-flag"}></i>
                </td>
              </tr>
            ))
            ):(
              <tr >
                <td colSpan={3} className="text-center text-dark my-3">
                  <span className="spinner spinner-border text-dark spinner-sm"></span> Loading...
                </td>
              </tr>
             
            )
          }
        </tbody>
      </Table>
    
    </Container>
  );

};

export default ReviewScreen;
